export default {"src":"/_next/static/media/logo-side-white.5f95a786.svg","height":117,"width":435,"blurWidth":0,"blurHeight":0};